// react redux
import { useSelector } from "react-redux";
// components
import CartItem from "../CartItem/CartItem";
import CartBundleItem from "../cartBundleItem/CartBundleItem";

const CartItems = () => {
  const cart = useSelector((state) => state.cart);

  return (
    <section className="w-full lg:w-3/4 flex flex-col gap-4">
      {cart.skus.map((cartItem, index) => (
        <CartItem key={index} item={cartItem} index={index} />
      ))}

      {cart.bundles.map((bundle) => (
        <CartBundleItem key={bundle.id} bundle={bundle} />
      ))}
    </section>
  );
};

export default CartItems;
